import React from "react";
import { formatLegacyScheduleHoursLabel } from "./clientScheduleGridUtils";
import ClientScheduleShiftRow from "./ClientScheduleShiftRow";

export default function ClientScheduleClientGroup({
  group,
  cardKey,
  isExpanded,
  onToggle,
  onShowNote,
}) {
  return (
    <div className="bg-gray-100 border rounded-lg hover:shadow-md transition-shadow border-gray-200">
      <div
        className="p-2 flex items-center justify-between cursor-pointer"
        onClick={() => onToggle(cardKey)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggle(cardKey);
          }
        }}
        role="button"
        tabIndex={0}
      >
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-semibold text-sm text-gray-900 truncate">
              {group.clientName}
            </span>
          </div>
          <span className="text-xs text-gray-500 truncate block">
            {group.locationName || group.sublocation}
          </span>
        </div>
        <div className="flex items-center gap-3 text-xs flex-shrink-0 ml-2">
          <div className="text-center">
            <div className="font-bold text-sm text-gray-900">
              {formatLegacyScheduleHoursLabel(group.totalHours)}
            </div>
            <div className="text-xs text-gray-500">HOURS</div>
          </div>
          <div className="text-center">
            <div className="font-bold text-xs">
              <span className="text-green-600">{group.confirmedCount}</span>
              <span className="text-black">/{group.requiredStaff}</span>
            </div>
            <div className="text-xs text-gray-500">SHIFTS</div>
          </div>
        </div>
      </div>

      {isExpanded ? (
        <div className="border-t border-gray-200 p-2 bg-gray-200 space-y-2">
          {(group.shifts || []).map((shift) => (
            <ClientScheduleShiftRow
              key={shift.shift_id}
              shift={shift}
              onShowNote={onShowNote}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}
